import { Gate } from "../apps/Gate.js";
import { VOGateEntry } from "../model/DataStructure.js";
import { Language } from "../model/Language.js";

export class GateOverlay {

    public onClose = e5.Signal.create<[boolean]>();
    public element: HTMLDivElement;

    private _gate: Gate;
    private _title: HTMLDivElement;
    private _description: HTMLDivElement;
    private _image: HTMLDivElement;
    private _open: boolean = false;

    constructor(gate: Gate) {
        this.element = document.createElement("div");
        this.element.id = "gate-overlay";
        this.element.innerHTML = `
        <div class="gate-overlay-title"></div>
        <div class="gate-overlay-description"></div>
        <div class="gate-overlay-image"></div>
        <div class="gate-overlay-close icon-607"></div>
        `;

        //777 was replaced :( we use 607 instead (Close icon)

        this._title = this.element.querySelector(".gate-overlay-title");
        this._description = this.element.querySelector(".gate-overlay-description");
        this._image = this.element.querySelector(".gate-overlay-image");
        var close = this.element.querySelector(".gate-overlay-close");

        close.addEventListener("pointerdown", () => {
            this.close(true);
        });
    }

    public open(data: VOGateEntry): void {
        this._open = true;
        if (!data) {
            this.close();
            return;
        }

        var hasTitle = Language.apply(this._title, data.gate_title_de, data.gate_title_en);
        var hasDescription = Language.apply(this._description, data.gate_description_de, data.gate_description_en);

        this._title.classList.toggle("hidden", !hasTitle);
        this._description.classList.toggle("hidden", !hasDescription);

        if (!hasTitle && !hasDescription && !data.gate_image) {
            return this.close();
        }

        if (data.gate_image) {
            this.element.setAttribute("data-layout", (!hasTitle && !hasDescription) ? "image" : "image-text");
            this._image.classList.remove("hidden");
            this._image.style.backgroundImage = "url(" + data.gate_image.url + ")";
        }
        else {
            this._image.classList.add("hidden");
            this.element.setAttribute("data-layout", "text");
        }

        this.element.classList.add("active");
    }

    public close(userInitiated: boolean = false): void {
        if (!this._open)
            return;
        this._open = false;
        this.element.classList.remove("active");
        this.onClose.dispatch(userInitiated);
    }
}